type NordicTrackingType = {
    eventChangeChatType?: (delay: NTDelayType | undefined) => void;
    eventChatBusy?: (proActive: boolean | undefined) => void;
    eventChatClosed?: (proActive: boolean | undefined) => void;
    eventChatConversationStarted?: () => void;
    eventChatEnded?: (proActive: boolean | undefined) => void;
    eventChatOpen?: (proActive: boolean | undefined) => void;
    eventChatTimeout?: (functionMode: string | undefined) => void;
    eventClosePanel?: (
        proActive: boolean | undefined,
        functionName: string | undefined,
        functionMode: string | undefined
    ) => void;
    eventCollapseIcon?: (panelStatus: string | undefined, proActive: boolean | undefined) => void;
    eventConversationHistory?: (proActive: boolean | undefined) => void;
    eventFirstMessageSentbyAdvisor?: () => void;
    eventFirstMessageSentbyCustomer?: () => void;
    eventFunctionIcon?: (proActive: boolean | undefined, functionName: string | undefined) => void;
    eventInternalFormOpened?: (
        proActive: boolean | undefined,
        functionName: string | undefined,
        functionMode: string | undefined
    ) => void;
    eventInternalFormSubmit?: (
        proActive: boolean | undefined,
        functionName: string | undefined,
        functionMode: string | undefined
    ) => void;
    eventMinimizePopup?: (
        proActive: boolean | undefined,
        functionStatus: string | undefined
    ) => void;
    eventOtherLink?: (
        proActive: boolean | undefined,
        functionName: string | undefined,
        value: string | undefined
    ) => void;
    eventPanelLoaded?: (
        panelStatus: string | undefined,
        proActive: boolean | undefined,
        functionName: string | undefined,
        functionMode: string | undefined,
        functionStatus: string | undefined
    ) => void;
    eventPhoneLink?: (
        proActive: boolean | undefined,
        functionName: string | undefined,
        value: string | undefined
    ) => void;
    eventStartChat?: (proActive: boolean | undefined, delay: NTDelayType | undefined) => void;
    setCategory?: (category: string | undefined) => void;
    panel?: () => NTPanelType;
    FUNCTIONINFO_MODE_AVAILABLE?: string;
    FUNCTIONINFO_MODE_BOT?: string;
    FUNCTIONINFO_MODE_NOTAVAILABLE?: string;
    FUNCTIONINFO_STATUS_ENDED?: string;
    FUNCTIONINFO_STATUS_NOTSTARTED?: string;
    FUNCTIONINFO_STATUS_PENDING?: string;
    FUNCTIONINFO_STATUS_STARTED?: string;
    FUNCTIONINFO_STATUS_TIMEDOUT?: string;
    PANELINFO_FUNCTION_NAME_CHAT?: string;
    PANELINFO_FUNCTION_NAME_EMAIL?: string;
    PANELINFO_FUNCTION_NAME_PHONE?: string;
    PANELINFO_FUNCTION_STATUS_AVAILABLE?: string;
    PANELINFO_FUNCTION_STATUS_BUSY?: string;
    PANELINFO_FUNCTION_STATUS_CLOSED?: string;
    PANELINFO_FUNCTION_STATUS_DIMMED?: string;
    PANELINFO_STATUS_COLLAPSED?: string;
    PANELINFO_STATUS_EXPANDED?: string;
    PANELINFO_STATUS_ONGOING?: string;
    ChangeChatType?: boolean;
    ConversationStarted?: boolean;
    CurrentCategory?: string | undefined;
    CurrentFunctionMode?: string | undefined;
    FirstMessageSentbyAdvisor?: boolean;
    FirstMessageSentbyCustomer?: boolean;
};

type NTFunctionType = {
    name: string;
    functionStatus: string | undefined;
};

type NTPanelInfoType = {
    allFunctions: NTFunctionType[];
    ignoreFunctions: string[];
};

type NTPanelType = {
    getFunction: (name: string) => NTFunctionType | undefined;
    setFunction: (name: string, functionStatus: string) => void;
    ignoreFunction: (name: string) => void;
    removeFunction: (name: string) => void;
};

type NTDelayType = {
    estimatedTime?: number;
    queue?: string;
};

type NTEventType = {
    event: string;
    panelInfo: {
        proactive: boolean;
        status: string | undefined;
        allFunctions: NTFunctionType[];
        selectedFunction: string | undefined;
    };
    functionInfo: {
        mode: string | undefined;
        status: string | undefined;
        action: string | undefined;
        linkUrl: string | undefined;
        category: string | undefined;
        delay: NTDelayType | undefined;
    };
};

/* eslint-disable no-unused-vars */
module.exports.NordicTracking = (): NordicTrackingType => {
    const self: NordicTrackingType = {};

    // constants
    const PANELINFO_STATUS_EXPANDED = (self.PANELINFO_STATUS_EXPANDED = 'expanded');
    const PANELINFO_STATUS_COLLAPSED = (self.PANELINFO_STATUS_COLLAPSED = 'collapsed');
    const PANELINFO_STATUS_ONGOING = (self.PANELINFO_STATUS_ONGOING = 'ongoing');

    const PANELINFO_FUNCTION_NAME_PHONE = (self.PANELINFO_FUNCTION_NAME_PHONE = 'phone');
    const PANELINFO_FUNCTION_NAME_CHAT = (self.PANELINFO_FUNCTION_NAME_CHAT = 'chat');
    const PANELINFO_FUNCTION_NAME_EMAIL = (self.PANELINFO_FUNCTION_NAME_EMAIL = 'email');

    const PANELINFO_FUNCTION_STATUS_AVAILABLE = (self.PANELINFO_FUNCTION_STATUS_AVAILABLE =
        'available');
    const PANELINFO_FUNCTION_STATUS_DIMMED = (self.PANELINFO_FUNCTION_STATUS_DIMMED = 'dimmed');
    const PANELINFO_FUNCTION_STATUS_BUSY = (self.PANELINFO_FUNCTION_STATUS_BUSY = 'busy');
    const PANELINFO_FUNCTION_STATUS_CLOSED = (self.PANELINFO_FUNCTION_STATUS_CLOSED = 'closed');

    const FUNCTIONINFO_MODE_AVAILABLE = (self.FUNCTIONINFO_MODE_AVAILABLE = 'available');
    const FUNCTIONINFO_MODE_NOTAVAILABLE = (self.FUNCTIONINFO_MODE_NOTAVAILABLE = 'not available');
    const FUNCTIONINFO_MODE_BOT = (self.FUNCTIONINFO_MODE_BOT = 'bot');

    const FUNCTIONINFO_STATUS_NOTSTARTED = (self.FUNCTIONINFO_STATUS_NOTSTARTED = 'not started');
    const FUNCTIONINFO_STATUS_PENDING = (self.FUNCTIONINFO_STATUS_PENDING = 'pending');
    const FUNCTIONINFO_STATUS_STARTED = (self.FUNCTIONINFO_STATUS_STARTED = 'started');
    const FUNCTIONINFO_STATUS_ENDED = (self.FUNCTIONINFO_STATUS_ENDED = 'ended');
    const FUNCTIONINFO_STATUS_TIMEDOUT = (self.FUNCTIONINFO_STATUS_TIMEDOUT = 'timeout');

    const FirstMessageSentbyCustomer = (self.FirstMessageSentbyCustomer = false);
    const FirstMessageSentbyAdvisor = (self.FirstMessageSentbyAdvisor = false);
    const ConversationStarted = (self.ConversationStarted = false);
    const ChangeChatType = (self.ChangeChatType = false); // bot -> human
    const CurrentFunctionMode = (self.CurrentFunctionMode = undefined); // chat, phone, email
    const CurrentCategory = (self.CurrentCategory = undefined); // queue selection prior to starting chat

    const panelInfo: NTPanelInfoType = {
        allFunctions: [],
        ignoreFunctions: [],
    };

    const getFunction = (name: string): NTFunctionType | undefined => {
        const func = panelInfo.allFunctions.filter((func) => func.name === name);
        return func.length ? func[0] : undefined;
    };

    const setFunction = (name: string, functionStatus: string | undefined): void => {
        const func = panelInfo.allFunctions.filter((func) => func.name === name);
        if (!func.length) {
            panelInfo.allFunctions.push({
                name: name,
                functionStatus: functionStatus
                    ? functionStatus
                    : PANELINFO_FUNCTION_STATUS_AVAILABLE,
            });
            return;
        }
        func[0].functionStatus = functionStatus;
    };

    const removeFunction = (name: string): void => {
        panelInfo.allFunctions = panelInfo.allFunctions.filter((func) => func.name !== name);
    };

    const ignoreFunction = (name: string): void => {
        panelInfo.ignoreFunctions.push(name);
    };

    const panel = (): NTPanelType => {
        return {
            getFunction: getFunction,
            setFunction: setFunction,
            removeFunction: removeFunction,
            ignoreFunction: ignoreFunction,
        };
    };
    self.panel = panel;

    const _baseEvent = (
        panelStatus: string | undefined,
        proActive: boolean | undefined,
        functionName: string | undefined,
        functionMode: string | undefined,
        functionStatus: string | undefined
    ): NTEventType => {
        // ifhelp does not know when there is a bot or not
        // when function does not exist, it means it is not enabled

        let defaultFunctionMode: string | undefined = FUNCTIONINFO_MODE_NOTAVAILABLE;
        const func = functionName ? panel().getFunction(functionName) : undefined;
        if (functionMode) defaultFunctionMode = functionMode;
        else if (func && func.functionStatus == PANELINFO_FUNCTION_STATUS_AVAILABLE)
            defaultFunctionMode = FUNCTIONINFO_MODE_AVAILABLE;
        else if (!func) defaultFunctionMode = undefined;

        const event: NTEventType = {
            event: 'Floating Contact Panel',
            panelInfo: {
                proactive: proActive ? proActive : false,
                status: panelStatus ? panelStatus : PANELINFO_STATUS_EXPANDED,
                allFunctions: panelInfo.allFunctions.filter(
                    (func) => !panelInfo.ignoreFunctions.includes(func.name)
                ),
                selectedFunction: functionName ? functionName : undefined,
            },
            functionInfo: {
                mode: defaultFunctionMode,
                status: functionStatus ? functionStatus : undefined,
                action: undefined,
                linkUrl: undefined,
                category: undefined,
                delay: undefined,
            },
        };

        if (functionName === PANELINFO_FUNCTION_NAME_CHAT)
            event.functionInfo.status = functionStatus
                ? functionStatus
                : FUNCTIONINFO_STATUS_NOTSTARTED;

        return event;
    };

    const reset = () => {
        self.FirstMessageSentbyCustomer = false;
        self.FirstMessageSentbyAdvisor = false;
        self.ConversationStarted = false;
        self.ChangeChatType = false;
        self.CurrentFunctionMode = undefined;
        self.CurrentCategory = undefined;
    };

    const sendEvent = (name: string, event: NTEventType): void => {
        if (/dev|test|127\.0\.0\.1|localhost/.test(window.location.href)) console.log(name, event);
        if (typeof (window as any).dataLayer === 'object') {
            setTimeout(() => {
                (window as any).dataLayer.push(event);
            }, 50);
        }
    };

    const setEventCategory = (event: NTEventType): void => {
        if (self.CurrentCategory) event.functionInfo.category = self.CurrentCategory;
    };

    self.eventPanelLoaded = (
        panelStatus: string | undefined,
        proActive: boolean | undefined,
        functionName: string | undefined,
        functionMode: string | undefined,
        functionStatus: string | undefined
    ): void => {
        if (!panelStatus) {
            console.log('eventPanelLoaded', 'Missing panel status');
            return;
        }

        const event = _baseEvent(
            panelStatus,
            proActive,
            functionName,
            functionMode,
            functionStatus
        );

        sendEvent('eventPanelLoaded', event);
    };

    self.eventCollapseIcon = (
        panelStatus: string | undefined,
        proActive: boolean | undefined
    ): void => {
        if (!panelStatus) {
            console.log('eventCollapseIcon', 'Missing panel status');
            return;
        }

        const event = _baseEvent(panelStatus, proActive, undefined, undefined, undefined);

        sendEvent('eventCollapseIcon', event);
    };

    self.eventFunctionIcon = (
        proActive: boolean | undefined,
        functionName: string | undefined
    ): void => {
        if (!functionName) {
            console.log('eventFunctionIcon', 'Missing function name');
            return;
        }

        const event = _baseEvent(undefined, proActive, functionName, undefined, undefined);

        sendEvent('eventFunctionIcon', event);
    };

    self.eventChatOpen = (proActive: boolean | undefined): void => {
        panel().setFunction(PANELINFO_FUNCTION_NAME_CHAT, PANELINFO_FUNCTION_STATUS_AVAILABLE);

        const event = _baseEvent(
            undefined,
            proActive,
            PANELINFO_FUNCTION_NAME_CHAT,
            FUNCTIONINFO_MODE_AVAILABLE,
            undefined
        );

        setEventCategory(event);
        sendEvent('eventFunctionIcon', event);
    };

    self.eventChatBusy = (proActive: boolean | undefined): void => {
        panel().setFunction(PANELINFO_FUNCTION_NAME_CHAT, PANELINFO_FUNCTION_STATUS_BUSY);

        const event = _baseEvent(
            undefined,
            proActive,
            PANELINFO_FUNCTION_NAME_CHAT,
            FUNCTIONINFO_MODE_NOTAVAILABLE,
            undefined
        );

        setEventCategory(event);
        sendEvent('eventFunctionIcon', event);
    };

    self.eventChatClosed = (proActive: boolean | undefined): void => {
        panel().setFunction(PANELINFO_FUNCTION_NAME_CHAT, PANELINFO_FUNCTION_STATUS_CLOSED);

        const event = _baseEvent(
            undefined,
            proActive,
            PANELINFO_FUNCTION_NAME_CHAT,
            FUNCTIONINFO_MODE_NOTAVAILABLE,
            undefined
        );

        setEventCategory(event);
        sendEvent('eventFunctionIcon', event);
    };

    self.eventClosePanel = (
        proActive: boolean | undefined,
        functionName: string | undefined,
        functionMode: string | undefined
    ): void => {
        const event = _baseEvent(
            PANELINFO_STATUS_COLLAPSED,
            proActive,
            functionName,
            functionMode,
            undefined
        );

        event.functionInfo.action = 'close';

        if (functionName === PANELINFO_FUNCTION_NAME_CHAT) setEventCategory(event);

        sendEvent('eventClosePanel', event);
    };

    self.eventPhoneLink = (
        proActive: boolean | undefined,
        functionName: string | undefined,
        value: string | undefined
    ): void => {
        const event = _baseEvent(undefined, proActive, functionName, undefined, undefined);

        event.functionInfo.action = 'call';
        event.functionInfo.linkUrl = value;

        sendEvent('eventPhoneLink', event);
    };

    self.eventOtherLink = (
        proActive: boolean | undefined,
        functionName: string | undefined,
        value: string | undefined
    ): void => {
        const event = _baseEvent(undefined, proActive, functionName, undefined, undefined);

        event.functionInfo.action = 'link';
        event.functionInfo.linkUrl = value;

        sendEvent('eventOtherLink', event);
    };

    self.eventInternalFormOpened = (
        proActive: boolean | undefined,
        functionName: string | undefined,
        functionMode: string | undefined
    ): void => {
        const event = _baseEvent(undefined, proActive, functionName, functionMode, undefined);

        event.functionInfo.action = 'panel form opened';

        sendEvent('eventInternalFormOpened', event);
    };

    self.eventInternalFormSubmit = (
        proActive: boolean | undefined,
        functionName: string | undefined,
        functionMode: string | undefined
    ): void => {
        const event = _baseEvent(undefined, proActive, functionName, functionMode, undefined);

        event.functionInfo.action = 'panel form submit';

        sendEvent('eventInternalFormSubmit', event);
    };

    self.eventStartChat = (
        proActive: boolean | undefined,
        delay: NTDelayType | undefined
    ): void => {
        self.CurrentFunctionMode = FUNCTIONINFO_MODE_AVAILABLE;

        const event = _baseEvent(
            undefined,
            proActive,
            PANELINFO_FUNCTION_NAME_CHAT,
            self.CurrentFunctionMode,
            FUNCTIONINFO_STATUS_PENDING
        );

        event.functionInfo.delay = {
            estimatedTime:
                delay && Object.prototype.hasOwnProperty.call(delay, 'estimatedTime')
                    ? delay.estimatedTime
                    : undefined,
            queue:
                delay && Object.prototype.hasOwnProperty.call(delay, 'queue')
                    ? delay.queue
                    : undefined,
        };

        setEventCategory(event);
        sendEvent('eventStartChat', event);
    };

    self.eventChatConversationStarted = (): void => {
        let functionMode = self.CurrentFunctionMode;

        if (
            functionMode !== FUNCTIONINFO_MODE_AVAILABLE &&
            functionMode !== FUNCTIONINFO_MODE_BOT
        ) {
            // console.log('eventChatConversationStarted', 'Invalid functionMode');
            // return;
            functionMode = FUNCTIONINFO_MODE_AVAILABLE;
        }

        const event = _baseEvent(
            undefined,
            false,
            PANELINFO_FUNCTION_NAME_CHAT,
            functionMode,
            FUNCTIONINFO_STATUS_STARTED
        );
        if (!self.ConversationStarted) {
            self.ConversationStarted = true;
            setEventCategory(event);
            sendEvent('eventChatConversationStarted', event);
        }
    };

    self.eventChangeChatType = (delay: NTDelayType | undefined): void => {
        const functionMode =
            self.CurrentFunctionMode === FUNCTIONINFO_MODE_AVAILABLE
                ? FUNCTIONINFO_MODE_BOT
                : FUNCTIONINFO_MODE_AVAILABLE;

        if (
            functionMode !== FUNCTIONINFO_MODE_AVAILABLE &&
            functionMode !== FUNCTIONINFO_MODE_BOT
        ) {
            console.log('eventChatConversationStarted', 'Invalid functionMode');
            return;
        }

        const event = _baseEvent(
            undefined,
            false,
            PANELINFO_FUNCTION_NAME_CHAT,
            functionMode,
            FUNCTIONINFO_STATUS_PENDING
        );

        event.functionInfo.action = 'chatbot to human chat';

        event.functionInfo.delay = {
            estimatedTime:
                delay && Object.prototype.hasOwnProperty.call(delay, 'estimatedTime')
                    ? delay.estimatedTime
                    : undefined,
            queue:
                delay && Object.prototype.hasOwnProperty.call(delay, 'queue')
                    ? delay.queue
                    : undefined,
        };

        if (!self.ChangeChatType) {
            self.ChangeChatType = true;
            sendEvent('eventChangeChatType', event);
        }
    };

    self.eventFirstMessageSentbyCustomer = (): void => {
        const functionMode = self.CurrentFunctionMode;

        if (
            functionMode !== FUNCTIONINFO_MODE_AVAILABLE &&
            functionMode !== FUNCTIONINFO_MODE_BOT
        ) {
            console.log('eventFirstMessageSentbyCustomer', 'Invalid functionMode');
            return;
        }

        const event = _baseEvent(
            undefined,
            false,
            PANELINFO_FUNCTION_NAME_CHAT,
            functionMode,
            FUNCTIONINFO_STATUS_STARTED
        );

        event.functionInfo.action = 'first customer action';

        if (!self.FirstMessageSentbyCustomer) {
            self.FirstMessageSentbyCustomer = true;
            sendEvent('eventFirstMessageSentbyCustomer', event);
        }
    };

    self.eventFirstMessageSentbyAdvisor = (): void => {
        const functionMode = self.CurrentFunctionMode;

        if (
            functionMode !== FUNCTIONINFO_MODE_AVAILABLE &&
            functionMode !== FUNCTIONINFO_MODE_BOT
        ) {
            console.log('eventFirstMessageSentbyAdvisor', 'Invalid functionMode');
            return;
        }

        const event = _baseEvent(
            undefined,
            false,
            PANELINFO_FUNCTION_NAME_CHAT,
            functionMode,
            FUNCTIONINFO_STATUS_STARTED
        );

        event.functionInfo.action = 'first advisor action';

        if (!self.FirstMessageSentbyAdvisor) {
            self.FirstMessageSentbyAdvisor = true;
            sendEvent('eventFirstMessageSentbyAdvisor', event);
        }
    };

    self.eventChatEnded = (proActive: boolean | undefined): void => {
        let functionMode = self.CurrentFunctionMode;

        if (
            functionMode !== FUNCTIONINFO_MODE_AVAILABLE &&
            functionMode !== FUNCTIONINFO_MODE_BOT
        ) {
            // console.log('eventChatEnded', 'Invalid functionMode');
            // return;
            functionMode = FUNCTIONINFO_MODE_AVAILABLE;
        }

        const event = _baseEvent(
            undefined,
            proActive,
            PANELINFO_FUNCTION_NAME_CHAT,
            functionMode,
            FUNCTIONINFO_STATUS_ENDED
        );

        setEventCategory(event);
        sendEvent('eventChatEnded', event);

        reset();
    };

    self.eventConversationHistory = (proActive: boolean | undefined): void => {
        const functionMode = self.CurrentFunctionMode;

        if (
            functionMode !== FUNCTIONINFO_MODE_AVAILABLE &&
            functionMode !== FUNCTIONINFO_MODE_BOT
        ) {
            console.log('eventConversationHistory', 'Invalid functionMode');
            return;
        }

        const event = _baseEvent(
            undefined,
            proActive,
            PANELINFO_FUNCTION_NAME_CHAT,
            functionMode,
            FUNCTIONINFO_STATUS_ENDED
        );

        event.functionInfo.action = 'history sent';

        sendEvent('eventConversationHistory', event);
    };

    self.eventMinimizePopup = (
        proActive: boolean | undefined,
        functionStatus: string | undefined
    ): void => {
        const functionMode = self.CurrentFunctionMode;

        if (
            functionMode !== FUNCTIONINFO_MODE_AVAILABLE &&
            functionMode !== FUNCTIONINFO_MODE_BOT
        ) {
            console.log('eventMinimizePopup', 'Invalid functionMode');
            return;
        }

        const event = _baseEvent(
            undefined,
            proActive,
            PANELINFO_FUNCTION_NAME_CHAT,
            functionMode,
            functionStatus
        );

        event.functionInfo.action = 'minimize';

        sendEvent('eventMinimizePopup', event);
    };

    self.eventChatTimeout = (functionMode: string | undefined): void => {
        if (
            functionMode !== FUNCTIONINFO_MODE_AVAILABLE &&
            functionMode !== FUNCTIONINFO_MODE_NOTAVAILABLE
        ) {
            console.log('eventChatTimeout', 'Invalid functionMode');
            return;
        }

        const event = _baseEvent(
            undefined,
            false,
            PANELINFO_FUNCTION_NAME_CHAT,
            functionMode,
            FUNCTIONINFO_STATUS_TIMEDOUT
        );

        sendEvent('eventChatTimeout', event);
    };

    self.setCategory = (category: string | undefined): void => {
        self.CurrentCategory = category;
    };

    return self;
};

module.exports.trackEvent = (event) => {
    if (typeof (window as any).dataLayer === 'object')
        (window as any).dataLayer.push({
            event: 'GAEvent',
            eventCategory: 'Help',
            eventAction: event,
            eventNonInteraction: false,
        });
    else if (typeof (window as any).ga === 'function') {
        (window as any).ga('send', 'event', 'Help', event);
    } else if (typeof (window as any)._gaq === 'object') {
        (window as any)._gaq.push(['_trackEvent', 'Help', event]);
    } else console.log('No analytics found, not tracking ' + event);
};
